/** Textos de interfaz, catálogo y trayectoria. Se fusionan en messages.js. */

export const siteCopy = {
  es: {
    ui: {
      seeMore: 'Ver más',
      close: 'Cerrar',
      closeMenu: 'Cerrar menú',
      quoteSubject: 'Cotización — {title}',
      quoteBody: 'Hola,\n\nMe interesa cotizar el servicio de {title}.\n\nSaludos.',
      prevSlide: 'Ver {label} anteriores',
      nextSlide: 'Ver {label} siguientes',
      carouselRegion: 'Carrusel de {label}',
    },
    career: {
      aria: 'Hitos de trayectoria',
      prev: 'Hito anterior',
      next: 'Hito siguiente',
      goTo: 'Ir a {title}',
      i: {
        title: 'Dirección Sinfónica en La Araucanía',
        text: 'Tras una destacada labor liderando la Orquesta Sinfónica Juvenil Armando Dufey (período consolidado hasta 2025), es actualmente director Titular de la Orquesta Sinfónica de la Universidad Católica de Temuco y de su Coro Sinfónico, impulsando la descentralización de la música clásica con montajes de alto nivel técnico.',
      },
      ii: {
        title: 'Grandes Óperas en Santiago',
        text: 'En la escena capitalina, destaca de forma recurrente su dirección musical para las producciones de Merlín Comunicaciones. Al mando de la Orquesta Filodramática de Chile, ha liderado con rotundo éxito de crítica y público obras cumbres del repertorio universal, incluyendo títulos estelares como Carmen de Bizet en teatros de renombre como CorpArtes y las conmemoraciones líricas internacionales en homenaje a Puccini (Gianni Schicchi) y Tosca entre otras. Recientemente Pagliacci y Cavalleria Rusticana.',
      },
      iii: {
        title: 'Catálogo de Partituras desde el Podio',
        text: 'Su experiencia guiando agrupaciones de cámara, coros y grandes orquestas sinfónicas en Europa y Chile se plasma en un catálogo exclusivo de arreglos, composiciones y orquestaciones. Cada partitura en esta tienda garantiza un balance sonoro óptimo, máxima legibilidad y soluciones orquestales pensadas por un director, para directores.',
      },
    },
    catalogue: {
      symphonic: 'Sinfónico',
      filmTitle: 'Música de Películas/Musicales',
      works: 'Obras disponibles',
      worksHint: 'Marca una o varias obras. El concierto completo desmarca el resto.',
      options: 'Opciones disponibles',
      optionsHint: 'Puedes solicitar una o varias opciones (Full Score, Score Coro y partichelas).',
      seeOptions: 'Ver opciones',
      noneSelected: 'Ninguna obra seleccionada',
      fullConcertSelected: 'Concierto completo seleccionado',
      oneWork: '1 obra seleccionada',
      nWorks: '{n} obras seleccionadas',
      fullConcert: 'Concierto completo',
      selectedWork: 'Obra seleccionada',
      soldOut: 'Agotado',
      optionsPrompt: 'Marca una o varias opciones. Precios en dólares americanos (USD).',
      noneOption: 'Ninguna opción seleccionada',
      oneOption: '1 opción seleccionada',
      nOptions: '{n} opciones seleccionadas',
      noChoir: 'No aplica (sin coro en la selección)',
      noChoirShort: 'No aplica (sin coro)',
      sumOfSome: 'Suma de {n} de {total} obras: {price}',
      sumOf: 'Suma de {n} obras: {price}',
      timesSome: '{price} × {n} de {total} obras',
      times: '{price} × {n} obras',
      totalZero: 'Total: US$ 0',
      totalQuote: 'Total: por cotizar (precios provisionales)',
      total: 'Total: {price}',
      promo: 'Precio promo (todas las opciones): {price}',
      requestWhatsapp: 'Solicitar selección por WhatsApp',
      requestHere: 'Solicita aquí',
      fullScore: 'Full Score Orquesta',
      choralScore: 'Score Coro',
      parts: 'Partituras de orquesta (set completo)',
      fullScoreDesc: 'Partitura completa para director y orquesta sinfónica.',
      choralScoreDesc: 'Partitura coral para ensayo y presentación.',
      partsDesc: 'Incluye todas las particellas del elenco. No se vende cada instrumento por separado.',
      queenOverture: 'Ouverture (incluye Innuendo)',
      overture: 'Obertura',
      overtureMedley: 'Obertura (Medley)',
      homeAlone: 'Somewhere in my memory (Mi pobre angelito)',
      letItGo: 'Let It Go (Frozen)',
      lionKing: 'Circle of Life (El Rey León)',
      spiderMan: 'Main Theme (Spider-Man)',
      avengers: 'Main Theme (The Avengers)',
      jurassic: 'Main Theme (Jurassic Park)',
      oz: 'Over the Rainbow (El Mago de Oz)',
      beauty: 'Suite orquestal (La Bella y la Bestia)',
      waIntro: 'Hola, quiero solicitar:',
      waWork: 'Obra:',
      waWorks: 'Obras:',
      waOption: 'Opción:',
      waOptions: 'Opciones:',
      waTotal: 'Total (USD): US$ {amount}',
      waPromo: 'Precio promo (todas las opciones): US$ {amount}',
    },
    whatsapp: {
      hero: 'Hola Eduardo, te contacto desde tu página web. Me gustaría conversar contigo sobre un proyecto musical.',
      footer: 'Hola Eduardo, estoy escribiendo desde tu página web y quisiera conversar contigo sobre un tema en particular. Estás disponible?',
    },
  },
  en: {
    ui: {
      seeMore: 'Read more',
      close: 'Close',
      closeMenu: 'Close',
      quoteSubject: 'Quote — {title}',
      quoteBody: 'Hello,\n\nI would like a quote for {title}.\n\nKind regards.',
      prevSlide: 'Previous {label}',
      nextSlide: 'Next {label}',
      carouselRegion: '{label} carousel',
    },
    career: {
      aria: 'Career highlights',
      prev: 'Previous highlight',
      next: 'Next highlight',
      goTo: 'Go to {title}',
      i: {
        title: 'Symphonic conducting in La Araucanía',
        text: 'After a distinguished tenure with the Armando Dufey Youth Symphony Orchestra, through 2025, he is now Music Director of the Universidad Católica de Temuco Symphony Orchestra and its Symphony Chorus, taking classical music of a high technical standard beyond the capital.',
      },
      ii: {
        title: 'Opera in Santiago',
        text: 'In Santiago he regularly conducts for Merlín Comunicaciones. With the Orquesta Filodramática de Chile he has led cornerstones of the operatic repertoire to a strong critical and public response, including Bizet’s Carmen at houses such as CorpArtes, and international celebrations of Puccini — Gianni Schicchi and Tosca among them. Most recently, Pagliacci and Cavalleria rusticana.',
      },
      iii: {
        title: 'A catalogue written from the podium',
        text: 'Years of conducting chamber ensembles, choruses and symphony orchestras in Europe and Chile are gathered here as an exclusive catalogue of arrangements, compositions and orchestrations. Every score in this shop is written for balance, for clear reading at the stand, and for orchestral solutions a conductor would hand to another conductor.',
      },
    },
    catalogue: {
      symphonic: 'Symphonic',
      filmTitle: 'Film and musical music',
      works: 'Works available',
      worksHint: 'Select one or more works. The complete concert clears the rest.',
      options: 'Formats available',
      optionsHint: 'You may order the full score, the choral score and the set of parts, together or separately.',
      seeOptions: 'See formats',
      noneSelected: 'No work selected',
      fullConcertSelected: 'Complete concert selected',
      oneWork: '1 work selected',
      nWorks: '{n} works selected',
      fullConcert: 'Complete concert',
      selectedWork: 'Selected work',
      soldOut: 'Sold out',
      optionsPrompt: 'Select one or more formats. Prices in US dollars (USD).',
      noneOption: 'No format selected',
      oneOption: '1 format selected',
      nOptions: '{n} formats selected',
      noChoir: 'Not included: this selection has no chorus',
      noChoirShort: 'Not included: no chorus',
      sumOfSome: '{n} of {total} works: {price}',
      sumOf: '{n} works: {price}',
      timesSome: '{price} × {n} of {total} works',
      times: '{price} × {n} works',
      totalZero: 'Total: US$ 0',
      totalQuote: 'Total: on request (provisional prices)',
      total: 'Total: {price}',
      promo: 'Bundle price (every format): {price}',
      requestWhatsapp: 'Send this selection on WhatsApp',
      requestHere: 'Enquire here',
      fullScore: 'Orchestral full score',
      choralScore: 'Choral score',
      parts: 'Orchestral parts (complete set)',
      fullScoreDesc: 'The complete score, for conductor and symphony orchestra.',
      choralScoreDesc: 'Choral score for rehearsal and performance.',
      partsDesc: 'Every part for the ensemble. Individual instruments are not sold separately.',
      queenOverture: 'Overture (includes Innuendo)',
      overture: 'Overture',
      overtureMedley: 'Overture (Medley)',
      homeAlone: 'Somewhere in my memory (Home Alone)',
      letItGo: 'Let It Go (Frozen)',
      lionKing: 'Circle of Life (The Lion King)',
      spiderMan: 'Main Theme (Spider-Man)',
      avengers: 'Main Theme (The Avengers)',
      jurassic: 'Main Theme (Jurassic Park)',
      oz: 'Over the Rainbow (The Wizard of Oz)',
      beauty: 'Orchestral suite (Beauty and the Beast)',
      waIntro: 'Hello, I would like to order:',
      waWork: 'Work:',
      waWorks: 'Works:',
      waOption: 'Format:',
      waOptions: 'Formats:',
      waTotal: 'Total (USD): US$ {amount}',
      waPromo: 'Bundle price (every format): US$ {amount}',
    },
    whatsapp: {
      hero: 'Hello Eduardo, I am writing from your website. I would like to talk with you about a musical project.',
      footer: 'Hello Eduardo, I am writing from your website and would like to speak with you. Are you available?',
    },
  },
  fr: {
    ui: {
      seeMore: 'En savoir plus',
      close: 'Fermer',
      closeMenu: 'Fermer',
      quoteSubject: 'Devis — {title}',
      quoteBody: 'Bonjour,\n\nJe souhaiterais un devis pour {title}.\n\nCordialement.',
      prevSlide: '{label} précédents',
      nextSlide: '{label} suivants',
      carouselRegion: 'Carrousel {label}',
    },
    career: {
      aria: 'Étapes du parcours',
      prev: 'Étape précédente',
      next: 'Étape suivante',
      goTo: 'Aller à {title}',
      i: {
        title: 'Direction symphonique en Araucanie',
        text: 'Après avoir dirigé l’Orchestre symphonique des jeunes Armando Dufey, jusqu’en 2025, il est aujourd’hui directeur musical de l’Orchestre symphonique de l’Universidad Católica de Temuco et de son Chœur symphonique, et porte la musique classique hors de la capitale avec des productions d’une haute exigence technique.',
      },
      ii: {
        title: 'L’opéra à Santiago',
        text: 'Sur la scène de Santiago, il dirige régulièrement pour Merlín Comunicaciones. À la tête de l’Orquesta Filodramática de Chile, il a mené des ouvrages centraux du répertoire lyrique, salués par la critique et le public : Carmen de Bizet dans des salles telles que CorpArtes, et des hommages internationaux à Puccini, dont Gianni Schicchi et Tosca. Plus récemment, Pagliacci et Cavalleria rusticana.',
      },
      iii: {
        title: 'Un catalogue écrit depuis le podium',
        text: 'Des années à diriger ensembles de chambre, chœurs et grands orchestres symphoniques en Europe et au Chili se retrouvent ici dans un catalogue exclusif d’arrangements, de compositions et d’orchestrations. Chaque partition de cette boutique est pensée pour l’équilibre sonore, pour une lecture claire au pupitre, et pour des solutions d’orchestre qu’un chef remettrait à un autre chef.',
      },
    },
    catalogue: {
      symphonic: 'Symphonique',
      filmTitle: 'Musiques de film et comédies musicales',
      works: 'Œuvres disponibles',
      worksHint: 'Choisissez une ou plusieurs œuvres. Le concert intégral retire les autres.',
      options: 'Formats disponibles',
      optionsHint: 'Vous pouvez commander le conducteur, la partition de chœur et le jeu de parties, ensemble ou séparément.',
      seeOptions: 'Voir les formats',
      noneSelected: 'Aucune œuvre sélectionnée',
      fullConcertSelected: 'Concert intégral sélectionné',
      oneWork: '1 œuvre sélectionnée',
      nWorks: '{n} œuvres sélectionnées',
      fullConcert: 'Concert intégral',
      selectedWork: 'Œuvre sélectionnée',
      soldOut: 'Épuisé',
      optionsPrompt: 'Choisissez un ou plusieurs formats. Prix en dollars américains (USD).',
      noneOption: 'Aucun format sélectionné',
      oneOption: '1 format sélectionné',
      nOptions: '{n} formats sélectionnés',
      noChoir: 'Non proposé : cette sélection n’a pas de chœur',
      noChoirShort: 'Non proposé : pas de chœur',
      sumOfSome: '{n} œuvres sur {total} : {price}',
      sumOf: '{n} œuvres : {price}',
      timesSome: '{price} × {n} sur {total} œuvres',
      times: '{price} × {n} œuvres',
      totalZero: 'Total : US$ 0',
      totalQuote: 'Total : sur devis (tarifs provisoires)',
      total: 'Total : {price}',
      promo: 'Tarif groupé (tous les formats) : {price}',
      requestWhatsapp: 'Envoyer cette sélection par WhatsApp',
      requestHere: 'Écrire ici',
      fullScore: 'Conducteur d’orchestre',
      choralScore: 'Partition de chœur',
      parts: 'Parties d’orchestre (jeu complet)',
      fullScoreDesc: 'La partition complète, pour le chef et l’orchestre symphonique.',
      choralScoreDesc: 'Partition chorale pour le travail en répétition et le concert.',
      partsDesc: 'L’ensemble des parties de l’effectif. Les instruments ne sont pas vendus séparément.',
      queenOverture: 'Ouverture (avec Innuendo)',
      overture: 'Ouverture',
      overtureMedley: 'Ouverture (medley)',
      homeAlone: 'Somewhere in my memory (Maman, j’ai raté l’avion)',
      letItGo: 'Let It Go (La Reine des neiges)',
      lionKing: 'Circle of Life (Le Roi lion)',
      spiderMan: 'Main Theme (Spider-Man)',
      avengers: 'Main Theme (Avengers)',
      jurassic: 'Main Theme (Jurassic Park)',
      oz: 'Over the Rainbow (Le Magicien d’Oz)',
      beauty: 'Suite d’orchestre (La Belle et la Bête)',
      waIntro: 'Bonjour, je souhaiterais commander :',
      waWork: 'Œuvre :',
      waWorks: 'Œuvres :',
      waOption: 'Format :',
      waOptions: 'Formats :',
      waTotal: 'Total (USD) : US$ {amount}',
      waPromo: 'Tarif groupé (tous les formats) : US$ {amount}',
    },
    whatsapp: {
      hero: 'Bonjour Eduardo, je vous écris depuis votre site. J’aimerais vous parler d’un projet musical.',
      footer: 'Bonjour Eduardo, je vous écris depuis votre site et j’aimerais échanger avec vous. Êtes-vous disponible ?',
    },
  },
  de: {
    ui: {
      seeMore: 'Mehr erfahren',
      close: 'Schließen',
      closeMenu: 'Schließen',
      quoteSubject: 'Anfrage — {title}',
      quoteBody: 'Guten Tag,\n\nich bitte um ein Angebot für {title}.\n\nMit freundlichen Grüßen.',
      prevSlide: 'Vorherige {label}',
      nextSlide: 'Nächste {label}',
      carouselRegion: 'Karussell {label}',
    },
    career: {
      aria: 'Stationen',
      prev: 'Vorherige Station',
      next: 'Nächste Station',
      goTo: 'Zu {title}',
      i: {
        title: 'Sinfonische Leitung in der Araucanía',
        text: 'Nach einer prägenden Zeit an der Spitze des Jugendsinfonieorchesters Armando Dufey, bis 2025, ist er heute Chefdirigent des Sinfonieorchesters der Universidad Católica de Temuco und seines Sinfonischen Chors und bringt klassische Musik auf hohem technischen Niveau über die Hauptstadt hinaus.',
      },
      ii: {
        title: 'Oper in Santiago',
        text: 'In Santiago dirigiert er regelmäßig für Merlín Comunicaciones. Mit der Orquesta Filodramática de Chile hat er tragende Werke des Opernrepertoires mit starker Resonanz bei Kritik und Publikum geleitet, darunter Bizets Carmen in Häusern wie CorpArtes und internationale Puccini-Ehrungen, unter anderem Gianni Schicchi und Tosca. Zuletzt Pagliacci und Cavalleria rusticana.',
      },
      iii: {
        title: 'Ein Katalog vom Pult aus',
        text: 'Jahre der Leitung von Kammerensembles, Chören und großen Sinfonieorchestern in Europa und Chile sind hier als exklusiver Katalog von Arrangements, Kompositionen und Orchestrationen versammelt. Jede Partitur in diesem Angebot ist auf klangliche Balance, auf klares Lesen am Pult und auf orchestrale Lösungen hin geschrieben, die ein Dirigent einem anderen Dirigenten anvertrauen würde.',
      },
    },
    catalogue: {
      symphonic: 'Sinfonisch',
      filmTitle: 'Film- und Musicalmusik',
      works: 'Verfügbare Werke',
      worksHint: 'Wählen Sie ein oder mehrere Werke. Das Gesamtkonzert hebt die übrigen auf.',
      options: 'Verfügbare Formate',
      optionsHint: 'Sie können Partitur, Chorpartitur und das Stimmenmaterial zusammen oder einzeln bestellen.',
      seeOptions: 'Formate ansehen',
      noneSelected: 'Kein Werk ausgewählt',
      fullConcertSelected: 'Gesamtkonzert ausgewählt',
      oneWork: '1 Werk ausgewählt',
      nWorks: '{n} Werke ausgewählt',
      fullConcert: 'Gesamtkonzert',
      selectedWork: 'Ausgewähltes Werk',
      soldOut: 'Vergriffen',
      optionsPrompt: 'Wählen Sie ein oder mehrere Formate. Preise in US-Dollar (USD).',
      noneOption: 'Kein Format ausgewählt',
      oneOption: '1 Format ausgewählt',
      nOptions: '{n} Formate ausgewählt',
      noChoir: 'Entfällt: in dieser Auswahl ist kein Chor vorgesehen',
      noChoirShort: 'Entfällt: ohne Chor',
      sumOfSome: '{n} von {total} Werken: {price}',
      sumOf: '{n} Werke: {price}',
      timesSome: '{price} × {n} von {total} Werken',
      times: '{price} × {n} Werken',
      totalZero: 'Gesamt: US$ 0',
      totalQuote: 'Gesamt: auf Anfrage (vorläufige Preise)',
      total: 'Gesamt: {price}',
      promo: 'Paketpreis (alle Formate): {price}',
      requestWhatsapp: 'Diese Auswahl per WhatsApp senden',
      requestHere: 'Hier anfragen',
      fullScore: 'Orchesterpartitur',
      choralScore: 'Chorpartitur',
      parts: 'Orchesterstimmen (komplettes Set)',
      fullScoreDesc: 'Die vollständige Partitur für Dirigent und Sinfonieorchester.',
      choralScoreDesc: 'Chorpartitur für Probe und Aufführung.',
      partsDesc: 'Alle Stimmen des Ensembles. Einzelne Instrumente werden nicht getrennt verkauft.',
      queenOverture: 'Ouvertüre (mit Innuendo)',
      overture: 'Ouvertüre',
      overtureMedley: 'Ouvertüre (Medley)',
      homeAlone: 'Somewhere in my memory (Kevin – Allein zu Haus)',
      letItGo: 'Let It Go (Die Eiskönigin)',
      lionKing: 'Circle of Life (Der König der Löwen)',
      spiderMan: 'Main Theme (Spider-Man)',
      avengers: 'Main Theme (The Avengers)',
      jurassic: 'Main Theme (Jurassic Park)',
      oz: 'Over the Rainbow (Der Zauberer von Oz)',
      beauty: 'Orchestersuite (Die Schöne und das Biest)',
      waIntro: 'Guten Tag, ich möchte bestellen:',
      waWork: 'Werk:',
      waWorks: 'Werke:',
      waOption: 'Format:',
      waOptions: 'Formate:',
      waTotal: 'Gesamt (USD): US$ {amount}',
      waPromo: 'Paketpreis (alle Formate): US$ {amount}',
    },
    whatsapp: {
      hero: 'Guten Tag, Eduardo, ich schreibe Ihnen über Ihre Website. Ich möchte mit Ihnen über ein musikalisches Projekt sprechen.',
      footer: 'Guten Tag, Eduardo, ich schreibe Ihnen über Ihre Website und möchte mit Ihnen sprechen. Haben Sie Zeit?',
    },
  },
  it: {
    ui: {
      seeMore: 'Scopri di più',
      close: 'Chiudi',
      closeMenu: 'Chiudi',
      quoteSubject: 'Preventivo — {title}',
      quoteBody: 'Buongiorno,\n\nvorrei un preventivo per {title}.\n\nCordiali saluti.',
      prevSlide: '{label} precedenti',
      nextSlide: '{label} successivi',
      carouselRegion: 'Carosello {label}',
    },
    career: {
      aria: 'Tappe del percorso',
      prev: 'Tappa precedente',
      next: 'Tappa successiva',
      goTo: 'Vai a {title}',
      i: {
        title: 'Direzione sinfonica in Araucanía',
        text: 'Dopo aver diretto l’Orchestra sinfonica giovanile Armando Dufey, fino al 2025, è oggi direttore musicale dell’Orchestra sinfonica dell’Universidad Católica de Temuco e del suo Coro sinfonico, e porta la musica classica fuori dalla capitale con produzioni di alto livello tecnico.',
      },
      ii: {
        title: 'L’opera a Santiago',
        text: 'Sulla scena di Santiago dirige regolarmente per Merlín Comunicaciones. Con l’Orquesta Filodramática de Chile ha guidato opere centrali del repertorio lirico, accolte con forza da critica e pubblico: la Carmen di Bizet in teatri come CorpArtes, e omaggi internazionali a Puccini, tra cui Gianni Schicchi e Tosca. Di recente, Pagliacci e Cavalleria rusticana.',
      },
      iii: {
        title: 'Un catalogo scritto dal podio',
        text: 'Anni di direzione di ensemble da camera, cori e grandi orchestre sinfoniche in Europa e in Cile confluiscono qui in un catalogo esclusivo di arrangiamenti, composizioni e orchestrazioni. Ogni partitura di questo negozio è pensata per l’equilibrio sonoro, per una lettura chiara sul leggio e per soluzioni orchestrali che un direttore affiderebbe a un altro direttore.',
      },
    },
    catalogue: {
      symphonic: 'Sinfonico',
      filmTitle: 'Musiche da film e musical',
      works: 'Brani disponibili',
      worksHint: 'Selezioni uno o più brani. Il concerto integrale toglie gli altri.',
      options: 'Formati disponibili',
      optionsHint: 'Può richiedere la partitura, la partitura corale e il set di parti, insieme o separatamente.',
      seeOptions: 'Vedi i formati',
      noneSelected: 'Nessun brano selezionato',
      fullConcertSelected: 'Concerto integrale selezionato',
      oneWork: '1 brano selezionato',
      nWorks: '{n} brani selezionati',
      fullConcert: 'Concerto integrale',
      selectedWork: 'Brano selezionato',
      soldOut: 'Esaurito',
      optionsPrompt: 'Selezioni uno o più formati. Prezzi in dollari statunitensi (USD).',
      noneOption: 'Nessun formato selezionato',
      oneOption: '1 formato selezionato',
      nOptions: '{n} formati selezionati',
      noChoir: 'Non previsto: questa selezione non ha coro',
      noChoirShort: 'Non previsto: senza coro',
      sumOfSome: '{n} brani su {total}: {price}',
      sumOf: '{n} brani: {price}',
      timesSome: '{price} × {n} su {total} brani',
      times: '{price} × {n} brani',
      totalZero: 'Totale: US$ 0',
      totalQuote: 'Totale: su richiesta (prezzi provvisori)',
      total: 'Totale: {price}',
      promo: 'Prezzo pacchetto (tutti i formati): {price}',
      requestWhatsapp: 'Inviare questa selezione su WhatsApp',
      requestHere: 'Richiedi qui',
      fullScore: 'Partitura d’orchestra',
      choralScore: 'Partitura corale',
      parts: 'Parti d’orchestra (set completo)',
      fullScoreDesc: 'La partitura completa, per direttore e orchestra sinfonica.',
      choralScoreDesc: 'Partitura corale per le prove e l’esecuzione.',
      partsDesc: 'Tutte le parti dell’organico. I singoli strumenti non si vendono separatamente.',
      queenOverture: 'Ouverture (include Innuendo)',
      overture: 'Ouverture',
      overtureMedley: 'Ouverture (medley)',
      homeAlone: 'Somewhere in my memory (Mamma, ho perso l’aereo)',
      letItGo: 'Let It Go (Frozen)',
      lionKing: 'Circle of Life (Il re leone)',
      spiderMan: 'Main Theme (Spider-Man)',
      avengers: 'Main Theme (The Avengers)',
      jurassic: 'Main Theme (Jurassic Park)',
      oz: 'Over the Rainbow (Il mago di Oz)',
      beauty: 'Suite orchestrale (La Bella e la Bestia)',
      waIntro: 'Buongiorno, vorrei ordinare:',
      waWork: 'Brano:',
      waWorks: 'Brani:',
      waOption: 'Formato:',
      waOptions: 'Formati:',
      waTotal: 'Totale (USD): US$ {amount}',
      waPromo: 'Prezzo pacchetto (tutti i formati): US$ {amount}',
    },
    whatsapp: {
      hero: 'Buongiorno Eduardo, le scrivo dal suo sito. Vorrei parlarle di un progetto musicale.',
      footer: 'Buongiorno Eduardo, le scrivo dal suo sito e vorrei parlare con lei. È disponibile?',
    },
  },
  pt: {
    ui: {
      seeMore: 'Saiba mais',
      close: 'Fechar',
      closeMenu: 'Fechar',
      quoteSubject: 'Orçamento — {title}',
      quoteBody: 'Olá,\n\nGostaria de um orçamento para {title}.\n\nCumprimentos.',
      prevSlide: '{label} anteriores',
      nextSlide: '{label} seguintes',
      carouselRegion: 'Carrossel de {label}',
    },
    career: {
      aria: 'Marcos da trajetória',
      prev: 'Marco anterior',
      next: 'Marco seguinte',
      goTo: 'Ir para {title}',
      i: {
        title: 'Direção sinfônica na Araucanía',
        text: 'Depois de dirigir a Orquestra Sinfônica Juvenil Armando Dufey, até 2025, é hoje diretor musical da Orquestra Sinfônica da Universidad Católica de Temuco e do seu Coro Sinfônico, e leva a música clássica para fora da capital com produções de alto nível técnico.',
      },
      ii: {
        title: 'Ópera em Santiago',
        text: 'No palco de Santiago dirige com regularidade para a Merlín Comunicaciones. À frente da Orquesta Filodramática de Chile, conduziu obras centrais do repertório lírico, com forte acolhida da crítica e do público, entre elas a Carmen de Bizet em salas como o CorpArtes, e homenagens internacionais a Puccini, incluindo Gianni Schicchi e Tosca. Mais recentemente, Pagliacci e Cavalleria rusticana.',
      },
      iii: {
        title: 'Um catálogo escrito a partir do pódio',
        text: 'Anos a dirigir conjuntos de câmara, coros e grandes orquestras sinfônicas na Europa e no Chile reúnem-se aqui num catálogo exclusivo de arranjos, composições e orquestrações. Cada partitura desta loja é pensada para o equilíbrio sonoro, para uma leitura clara na estante e para soluções orquestrais que um maestro entregaria a outro maestro.',
      },
    },
    catalogue: {
      symphonic: 'Sinfônico',
      filmTitle: 'Música de filmes e musicais',
      works: 'Obras disponíveis',
      worksHint: 'Marque uma ou várias obras. O concerto completo desmarca as restantes.',
      options: 'Formatos disponíveis',
      optionsHint: 'Pode pedir a partitura geral, a partitura coral e o conjunto de partes, juntos ou em separado.',
      seeOptions: 'Ver formatos',
      noneSelected: 'Nenhuma obra selecionada',
      fullConcertSelected: 'Concerto completo selecionado',
      oneWork: '1 obra selecionada',
      nWorks: '{n} obras selecionadas',
      fullConcert: 'Concerto completo',
      selectedWork: 'Obra selecionada',
      soldOut: 'Esgotado',
      optionsPrompt: 'Marque um ou vários formatos. Preços em dólares americanos (USD).',
      noneOption: 'Nenhum formato selecionado',
      oneOption: '1 formato selecionado',
      nOptions: '{n} formatos selecionados',
      noChoir: 'Não se aplica: esta seleção não tem coro',
      noChoirShort: 'Não se aplica: sem coro',
      sumOfSome: '{n} de {total} obras: {price}',
      sumOf: '{n} obras: {price}',
      timesSome: '{price} × {n} de {total} obras',
      times: '{price} × {n} obras',
      totalZero: 'Total: US$ 0',
      totalQuote: 'Total: sob consulta (preços provisórios)',
      total: 'Total: {price}',
      promo: 'Preço de pacote (todos os formatos): {price}',
      requestWhatsapp: 'Enviar esta seleção por WhatsApp',
      requestHere: 'Solicitar aqui',
      fullScore: 'Partitura geral de orquestra',
      choralScore: 'Partitura coral',
      parts: 'Partes de orquestra (conjunto completo)',
      fullScoreDesc: 'A partitura completa, para maestro e orquestra sinfônica.',
      choralScoreDesc: 'Partitura coral para ensaio e apresentação.',
      partsDesc: 'Todas as partes do efetivo. Os instrumentos não são vendidos em separado.',
      queenOverture: 'Abertura (inclui Innuendo)',
      overture: 'Abertura',
      overtureMedley: 'Abertura (medley)',
      homeAlone: 'Somewhere in my memory (Esqueceram de Mim)',
      letItGo: 'Let It Go (Frozen)',
      lionKing: 'Circle of Life (O Rei Leão)',
      spiderMan: 'Main Theme (Spider-Man)',
      avengers: 'Main Theme (The Avengers)',
      jurassic: 'Main Theme (Jurassic Park)',
      oz: 'Over the Rainbow (O Mágico de Oz)',
      beauty: 'Suite orquestral (A Bela e a Fera)',
      waIntro: 'Olá, gostaria de solicitar:',
      waWork: 'Obra:',
      waWorks: 'Obras:',
      waOption: 'Formato:',
      waOptions: 'Formatos:',
      waTotal: 'Total (USD): US$ {amount}',
      waPromo: 'Preço de pacote (todos os formatos): US$ {amount}',
    },
    whatsapp: {
      hero: 'Olá, Eduardo, escrevo a partir do seu site. Gostaria de conversar sobre um projeto musical.',
      footer: 'Olá, Eduardo, escrevo a partir do seu site e gostaria de falar consigo. Está disponível?',
    },
  },
}
